import React from "react";
import { string } from "prop-types";

const LeftArrowButton = ({ color = "#4785ff", datatrackingcategory, datatrackingaction, datatrackinglabel }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60">
    <defs>
      <filter id="a" width="60" height="60" x="0" y="0" filterUnits="userSpaceOnUse">
        <feOffset dy="3" />
        <feGaussianBlur result="blur" stdDeviation="3" />
        <feFlood floodOpacity=".322" />
        <feComposite in2="blur" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g data-name="Group 3577">
      <g filter="url(#a)">
        <circle
          cx="21"
          cy="21"
          r="21"
          data-name="Ellipse 68"
          transform="rotate(180 25.5 24)"
          fill={color}
          data-tracking-category={datatrackingcategory}
          data-tracking-action={datatrackingaction}
          data-tracking-label={datatrackinglabel}
        />
      </g>
      <path
        d="M34.5 35.499l-8-8 8-8"
        data-name="Path 51"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="1"
      />
    </g>
  </svg>
);

LeftArrowButton.propTypes = {
  color: string,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
};

export default LeftArrowButton;
